import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BackButton } from '@vkruglikov/react-telegram-web-app';

import BasicPanel from '../../components/panels/basicPanel/basicPanel';
import BasicWrapper from '../../components/basicWrapper/basicWrapper';
import { instructionsList } from '../../config/instructionsList';

import './instructionsList.css';
import { isIOSVersionHigherThan26Version } from '../../utils/getUserAgentParser';

const INSTRUCTIONS_LIST_PATH = '/instructions_list';

export function getInstructionsListPath() {
    return INSTRUCTIONS_LIST_PATH;
}

export default function InstructionsList() {
    const { t } = useTranslation('basic');
    const navigate = useNavigate();

    const isIOS26Version = isIOSVersionHigherThan26Version();

    const openInstruction = (url) => {
        const key = encodeURIComponent(url);
        navigate(`/instructions?key=${key}`);
    };

    return (
        <div className={`instructionsListWrapper stepsHeaderWrapper gradient_bg_header ${isIOS26Version ? 'ios26_top-safe-area' : ''}`}>
            <BackButton onClick={() => navigate(-1)} />
            <BasicWrapper>
                <div className="instructionsList_header">
                    <div className="stepHeaderHeader heading-h4">
                        {t('instructions_list_title')}
                        <img
                            id="stepsHeaderImage"
                            src="https://s3.timeweb.com/8a6e091b-publick/template_header.png"
                            alt=""
                        />
                    </div>
                </div>
                <ul className="instructionsList_list">
                    {instructionsList.map(({ titleKey, url }) => (
                        <li key={url} className="instructionsList_item">
                            <BasicPanel>
                                <button
                                    type="button"
                                    className="instructionsList_card"
                                    onClick={() => openInstruction(url)}
                                >
                                    <span className="paragraph-16M">
                                        {t(titleKey)}
                                    </span>
                                </button>
                            </BasicPanel>
                        </li>
                    ))}
                </ul>
            </BasicWrapper>
        </div>
    );
}
